<template>
<div class="login-container">
  <form method="POST" v-on:submit.prevent="onSubmit()">
    <mu-paper class="login-paper" rounded :zDepth="1" >
      <div class="login-logo">
        <img src="../assets/logo_log.svg" alt="logo" width="150" />
      </div>
      <div class="login-logo">
        <mu-text-field hintText="Identifiant" autofocus v-model="formData.login" lazy ></mu-text-field><br>
        <mu-text-field hintText="Mot de passe" 
          type="password" 
          @keyup.native.enter="connect()"
          v-model="formData.password" lazy></mu-text-field><br>
        <mu-select-field v-model="pref.baseURL" @change="savePref">
          <mu-menu-item value="api" title="Agence 47"></mu-menu-item>
          <mu-menu-item value="api32" title="Agence 32"></mu-menu-item>
        </mu-select-field>
        <mu-checkbox v-model="formData.persist" label="Se souvenir de moi" class=""></mu-checkbox>
      </div>
      <div class="login-logo">
        <mu-raised-button 
          v-if="!badAuth" 
          @click.prevent="onSubmit()" 
          label="Se connecter" type="submit" backgroundColor="#a4c639" style="width:256px;"></mu-raised-button>
          <div v-if="badAuth" class="bs-callout bs-callout-danger">
                <i>Login ou mot de pass invalide !</i><br>
          </div>
      </div>
      <div>&nbsp;</div>
    </mu-paper>
  </form>
</div>
</template>

<script>
import paper        from 'muse-components/paper'
import textField    from 'muse-components/textField'
import flatButton   from 'muse-components/flatButton'
import raisedButton from 'muse-components/raisedButton'
import checkbox     from 'muse-components/checkbox'
import selectField  from 'muse-components/selectField'
import {menu, menuItem} from 'muse-components/menu'
import "../configTheme.less"
import "../config.less"

export default {
  name: 'login',
  data () {
    return {
      checkAuth: false,
      badAuth: false,
      formData : {
        login: '',
        password: '',
        persist: false,
        _path: 'auth',
        _method: 'GET'
      },
      pref: this.$auth.userPref
    }
  },
  methods: {
    connect() {
      this.onSubmit()
    },
    onSubmit: function() {
      var self = this
      this.$auth.login( this.formData, function(result){
        if( result ){
          self.$router.push({ path: '/dashboard' })
        } else {
          self.badAuth = true
          setTimeout( () => {
            self.badAuth = false
          }, 2000 )
        }
      })
    },
    savePref: function(val){
      this.pref.baseURL = val
      window.axios.defaults.baseURL = this.pref.baseURL
      ns.localStorage.set( APP_COD + "_pref", this.pref )
    }
  },
  components: {
      'mu-paper': paper,
      'mu-text-field': textField,
      'mu-flat-button': flatButton,
      'mu-raised-button': raisedButton,
      'mu-checkbox': checkbox,
      'mu-select-field': selectField,
      'mu-menu': menu, 'mu-menu-item': menuItem
  }
}
</script>

<style lang="css">
/* Personnalisation code */
.login-container {
  transform: translate(0, -50px);
  padding-top: 2em;
}
.login-paper {
  width: 24em;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}
.login-logo {
  margin-bottom: 1.2em;
  padding-top: 0.5em;
}

</style>


// WEBPACK FOOTER //
// Login.vue?694f0ba4